module.exports = __webpack_public_path__ + "static/img/baseAbout2.59731e98.png";